import { render, staticRenderFns } from "./MedexperienceBody.vue?vue&type=template&id=773f5f22&scoped=true&"
import script from "./MedexperienceBody.vue?vue&type=script&lang=ts&"
export * from "./MedexperienceBody.vue?vue&type=script&lang=ts&"
import style0 from "./MedexperienceBody.vue?vue&type=style&index=0&id=773f5f22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773f5f22",
  null
  
)

export default component.exports